var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "footer-main branding-bg",
      attrs: { id: "VueFooter", "data-trackname": "footer" }
    },
    [
      _c("div", { staticClass: "container container-kernel" }, [
        _c("p", [_vm._v("© " + _vm._s(_vm.year) + " Nedgia")])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/Footer.vue?vue&type=template&id=27f46840&
// module id = null
// module chunks = 